import MainLayout from '@/component/layout/MainLayout'
import RedirectLayout from '@/component/layout/RedirectLayout'
import Toast from '@/component/Toast'
import i18n from '@/i18n'
import React from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'

const AuthRequired = React.lazy(() => import('@/component/AuthRequired'))

const withLazyLoading = (loader: () => Promise<{ default: React.ComponentType }>) => {
  return async () => {
    const close = Toast.show({
      content: i18n.t('app.loading'),
      icon: 'loading',
      duration: 0
    })
    try {
      const mod = await loader()
      close()
      const Component = mod.default
      return {
        element: <Component />
      }
    } catch (error) {
      close()
      throw error
    }
  }
}

const routes: RouteObject[] = [
  {
    path: '/',
    children: [
      {
        // 处理跳转
        index: true,
        element: <RedirectLayout />
      },
      // 兼容旧版本的 URL 格式，tiptop渠道
      // TODO: 后续需要删除
      {
        path: '/en/tiptop/',
        element: <Navigate to="/tiptop/" replace />
      },
      {
        path: '/:channel/',
        element: <MainLayout />,
        children: [
          {
            index: true,
            lazy: async () => {
              return {
                Component: (await import('../page/Home')).default
              }
            }
          },
          {
            path: 'my/',
            lazy: async () => {
              const page = await withLazyLoading(() => import('../page/My'))()
              return {
                element: <AuthRequired>{page.element}</AuthRequired>
              }
            }
          },
          {
            path: 'play/:code/',
            lazy: withLazyLoading(() => import('../page/Play'))
          },
          {
            path: 'battle/:code/',
            lazy: async () => {
              const page = await withLazyLoading(() => import('../page/Battle'))()
              return {
                element: <AuthRequired>{page.element}</AuthRequired>
              }
            }
          },
          {
            path: 'tags/',
            lazy: withLazyLoading(() => import('../page/TagList'))
          },
          {
            path: 'tag/:code/',
            lazy: withLazyLoading(() => import('../page/Tag'))
          },
          {
            path: 'games/',
            lazy: withLazyLoading(() => import('../page/GameList'))
          },
          {
            path: 'recent/',
            lazy: withLazyLoading(() => import('../page/Recent'))
          },
          {
            path: 'new/',
            lazy: withLazyLoading(() => import('../page/Recommend')),
            loader: () => 'new'
          },
          {
            path: 'hot/',
            id: 'hot',
            lazy: withLazyLoading(() => import('../page/Recommend')),
            loader: () => 'hot'
          },
          {
            path: 'search/',
            lazy: withLazyLoading(() => import('../page/Search'))
          },
          {
            path: 'pay-result/',
            lazy: withLazyLoading(() => import('../page/PayResult'))
          },
          {
            path: 'terms/',
            id: 'terms',
            lazy: withLazyLoading(() => import('../page/Law')),
            loader: () => 'terms'
          },
          {
            path: 'privacy/',
            id: 'privacy',
            lazy: withLazyLoading(() => import('../page/Law')),
            loader: () => 'privacy'
          },
          {
            path: 'cookies/',
            id: 'cookies',
            lazy: withLazyLoading(() => import('../page/Law')),
            loader: () => 'cookies'
          }
        ]
      },
      {
        path: '*',
        element: <RedirectLayout />
      }
    ]
  },
  {
    path: '/test/',
    lazy: withLazyLoading(() => import('../page/TestGame'))
  },
  {
    path: 'debug/',
    lazy: withLazyLoading(() => import('../page/Debug'))
  }
]

export default routes
